module.exports = __webpack_public_path__ + "img/euro-pound.cec9de31.png";